import React from "react";

import Button from "@mui/joy/Button";
import {Stack} from "@mui/joy";

// components
import UserSubscriberContext from "../../../context/UserSubscriberContext";
import Typography from "@mui/joy/Typography";
import BaseApi from "../../../utils/BaseApi";
import RoadRunnerListModal from "./RoadRunnerListModal";


class RoadRunner extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            started: false,
            score: null,
            saved: false,
        };

        this.interval = 16

        this.width = 600
        this.height = 800

        this.score = 0
        this.speed = 8

        this.objs = [
            {emoji: '😈', speed: this.speed, class: 'enemy',},
            {emoji: '💀', speed: this.speed, class: 'enemy',},
            {emoji: '👾', speed: this.speed, class: 'enemy',},
            {emoji: '💰', speed: this.speed, class: 'bonus',},
            {emoji: '🌟', speed: this.speed, class: 'bonus',},
            {emoji: '🍕', speed: this.speed, class: 'bonus',},
        ];

        this.emojiCache = {}

        this.objHeight = 50
        this.objWidth = 50

        this.roads = {
            num: 4,
            width: 100
        }
        this.width = this.roads.num * this.roads.width
        this.height = 500

        this.player = {
            road: 2,
        };
        this.player.x = this.roads.width * this.player.road
        this.player.y = this.height - this.objHeight

        this.gameObjs = []

        this.canvasRef = React.createRef()

        this.lastTime = 0;
        this.lastSpawnTime = performance.now();
        this.spawnInterval = 350;

        this.animationId = null;

        this.handleKeys = this.handleKeys.bind(this);
        this.animate = this.animate.bind(this);

    }

    chooseObj() {
        return this.objs[Math.floor(Math.random() * this.objs.length)]
    }

    // Обновление бонусов
    updateObjects(deltaTime) {
        const player = this.player
        const now = performance.now();

        const speedFactor = deltaTime / this.interval;

        for (let i = this.gameObjs.length - 1; i >= 0; i--) {
            const g = this.gameObjs[i];
            g.y += g.obj.speed * speedFactor;

            // 🔥 Оптимизация: проверка коллизий только в зоне игрока
            if (g.y + this.objHeight > player.y && g.y < player.y + this.objHeight) {
                if (this.checkCollision(player, g)) {
                    if (g.obj.class === 'bonus') {
                        this.score += 10;
                        this.gameObjs.splice(i, 1);
                    } else {
                        this.endGame();
                        return;
                    }
                }
            }

            // Удаляем ушедшие за экран
            if (g.y > this.height - this.objHeight) {
                this.gameObjs.splice(i, 1);
            }
        }

        // Добавляем объект
        if (now - this.lastSpawnTime >= this.spawnInterval) {
            this.gameObjs.push({
                obj: this.chooseObj(),
                x: Math.floor(Math.random() * this.roads.num) * this.roads.width,
                y: 0
            });
            this.lastSpawnTime = now; // Reset timer
        }

    }

    checkCollision(r1, r2) {
        return !(
            r2.x > r1.x + this.objWidth ||
            r2.x + this.objWidth < r1.x ||
            r2.y > r1.y + this.objHeight ||
            r2.y + this.objHeight < r1.y
        );
    }

    createEmojiCache(){
        const emojis = [...new Set(this.objs.map(o => o.emoji)), '🚗'];
        emojis.forEach(emoji => {
            const canvas = document.createElement('canvas');
            canvas.width = this.objWidth;
            canvas.height = this.objHeight + 10;
            const ctx = canvas.getContext('2d');
            ctx.font = `${this.objHeight - 10}px sans-serif`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(emoji, this.objWidth / 2, this.objHeight / 2);
            this.emojiCache[emoji] = canvas;
        });
    };

    draw() {
        // Очистка
        this.ctx.clearRect(0, 0, this.width, this.height);

        this.ctx.fillStyle = 'grey';
        this.ctx.fillRect(
            0,
            0,
            this.width,
            this.height
        );
        this.ctx.fillStyle = 'black';

        const playerDrawX = this.player.road * this.roads.width + this.objWidth / 2 ;
        const playerDrawY = this.player.y - this.objHeight / 2;

        if (this.emojiCache['🚗']) {
            this.ctx.drawImage(
                this.emojiCache['🚗'],
                playerDrawX,
                playerDrawY
            );
        }

        // 🎯 Объекты: аналогично
        this.gameObjs.forEach(g => {
            const drawX = g.x + this.objWidth/ 2;
            const drawY = g.y - this.objHeight / 2;

            if (this.emojiCache[g.obj.emoji]) {
                this.ctx.drawImage(
                    this.emojiCache[g.obj.emoji],
                    drawX,
                    drawY
                );
            }
        });

        // Отображение счета
        this.ctx.font = '20px sans-serif';
        this.ctx.fillText('Счет: ' + this.score, 10, 30);
    }

    animate() {
        this.animationId = requestAnimationFrame(this.animate);

        if (!this.ctx) return;

        const currentTime = performance.now();
        const deltaTime = currentTime - this.lastTime;

        if (deltaTime >= this.interval) {
            this.updateObjects(deltaTime);
            this.draw();
            this.lastTime = currentTime
        }
    };

    handleKeys(e){
        if (e.key === 'ArrowLeft' || e.key === 'a') {
            this.player.road = Math.max(
                0,
                this.player.road - 1
            );
        } else if (e.key === 'ArrowRight' || e.key === 'd') {
            this.player.road = Math.min(
                this.roads.num - 1,
                this.player.road + 1
            );
        }
        this.player.x = this.player.road * this.roads.width;
    }

    componentDidMount() {
        this._isMounted = true;
        this.createEmojiCache();
        document.addEventListener(
            'keydown',
            this.handleKeys
        );
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
        }
        document.removeEventListener(
            'keydown',
            this.handleKeys
        )
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.started !== nextState.started ||
            this.state.score !== nextState.score ||
            this.state.saved !== nextState.saved
        );
    }

    resetGame(){
        this.score = 0;
        this.gameObjs = [];

        this.player = {
            road: 2,
            x: this.roads.width * 2,
            y: this.height - this.objHeight
        };

        // Clear canvas visually too
        if (this.ctx) {
            this.ctx.clearRect(0, 0, this.width, this.height);
        }
    };

    startGame(){
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
        }

        if (!this.canvasRef.current) return;

        this.ctx = this.canvasRef.current.getContext(
            '2d',
            {
                alpha: false
            }
        );
        this.ctx.imageSmoothingEnabled = false;

        this.lastTime = performance.now();
        this.lastSpawnTime = performance.now();

        this.setState(
            {
                started: true,
                saved: false
            },
            this.animate
        )
    }

    endGame(){
        this.setState({
            started: false,
            score: Math.max(this.state.score || 0, this.score),
            saved: false,
        })

        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
            this.animationId = null;
        }

        this.resetGame();
    }

    async saveResult(){
        const url = `game_result/`;
        const api = new BaseApi();
        await api.post(
            url,
            {
                subscriber: this.context.subscriberObject.id,
                game: 'road_runner',
                result: this.state.score,
            }
        );
        this.setState({
            saved: true,
        })
    }

    render() {
        return(
            <Stack
                sx={{
                    width: '100%',
                    alignItems: 'center'
                }}
                spacing={1}
            >
                <canvas
                    style={{
                        border: '2px',
                    }}
                    id={'canvas'}
                    width={this.width}
                    height={this.height}
                    ref={this.canvasRef}
                >
                </canvas>
                <Typography>
                    Управление A, D или Left, Right
                </Typography>
                {
                    this.state.score ?
                        <Stack
                            direction={'row'}
                            spacing={1}
                            sx={{
                                flexWrap: 'wrap',
                            }}
                            alignItems={'center'}
                        >
                            <Typography>
                                Лучший результат: {this.state.score}
                            </Typography>
                            {
                                !this.state.saved ?
                                    <Button
                                        onClick={this.saveResult.bind(this)}
                                    >
                                        Сохранить
                                    </Button>:
                                    null
                            }
                        </Stack>:
                        null
                }
                {
                    !this.state.started?
                        <Stack
                            direction={'row'}
                            spacing={1}
                            sx={{
                                flexWrap: 'wrap',
                            }}
                            alignItems={'center'}
                        >
                            <Button
                                onClick={this.startGame.bind(this)}
                                color={'success'}
                            >
                                Начать {this.score ? 'заново' : null}
                            </Button>
                            <RoadRunnerListModal />
                        </Stack>:
                        null
                }
            </Stack>
        )
    }
}

export default RoadRunner